import formatValue from "../../utils/formatValue";

export const REQUIREMENTS_PREVIEW_LENGTH = 72;

export function offerLinkLabel(status: number): string {
  if (status === 1 || status === 3) return "PROPOSTA ACEITA";
  if (status === 4) return "PROPOSTA CANCELADA";
  return "ACOMPANHAR PROPOSTA";
}

export function offerStatusBadge(status: number): {
  label: string;
  className: string;
} {
  if (status === 1 || status === 3) {
    return {
      label: "Aceita",
      className: "border-emerald-200 bg-emerald-50 text-emerald-800",
    };
  }
  if (status === 4) {
    return {
      label: "Cancelada",
      className: "border-red-200 bg-red-50 text-red-800",
    };
  }
  return {
    label: "Em andamento",
    className: "border-sky-200 bg-sky-50 text-sky-800",
  };
}

export function formatOfferValue(value: string | number | null | undefined): string {
  if (value == null || String(value).trim() === "") return "—";
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return formatValue(amount);
}
